import React from "react";
import {
    Box,
    Paper,
    Typography,
    useMediaQuery,
    useTheme,

} from "@mui/material";
import Calculator from "../CalculatorGrid";
import CashCourse from "../CashCourses";
import OnlineCourse from "../OnlineCourses";
import { useAppContext } from "../../context";



export default function   Courses() {
const { onlineCourse, officialCourse, tableTitle } = useAppContext();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    return (
        <>
            <Calculator />
            <Box sx={{ px: { xs: 1, md: 0 }, py: 2 }}>
                <Paper
                    sx={{
                        p: { xs: 1.5, md: 2 },
                        mb: 3,
                        borderRadius: 3,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                    }}
                >
                    {/* TITLE */}
                    <Typography
                        className="font-helviteca text-blue-80"
                        sx={{ fontWeight: 600, mb: 1, px: 1 }}
                    >
                        {tableTitle}
                    </Typography>

                    {/* TABLE WRAPPER */}
                    <Paper
                        sx={{
                            borderRadius: 3,
                            overflow: "hidden",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.04)",
                        }}
                    >
                        {/* DESKTOP HEADER */}
                        {!isMobile && (
                            <Box
                                className="font-helviteca text-blue-80"
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 2fr 1fr 1fr 60px",
                                    p: 2,
                                    background: "#f6f7fb",
                                    fontWeight: 600,
                                    color: "#555",
                                    textAlign: "center",
                                }}
                            >
                                <Box>ვალუტა</Box>
                                {officialCourse && <Box>ოფიციალური კურსი</Box>}
                                <Box>ყიდვა</Box>
                                <Box>გაყიდვა</Box>
                                <Box />
                            </Box>
                        )}
                        {!onlineCourse && <CashCourse />}
                        {onlineCourse && <OnlineCourse />}
                    </Paper>
                </Paper>
            </Box>


        </>
    );
}
